<ng-container *ngrxLet="auction$ as auction">
  <a class="secondary-link no-decoration" *ngIf="segment" [routerLink]="mergeRouter(auction)">
    {{ auction?.title }}
  </a>
</ng-container>
